import React from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import Loader from '../../loader'
import PopUp from '../../pop-up'
import NotificationItem from './notification'

import { useGeneralNotifications } from '../../../../data/hooks/notifications'
import { useAuth } from '../../../../data/hooks/auth'

type NotificationsDropdownProps = {
  isOpen: boolean
}

const NotificationsDropdown: React.FunctionComponent<NotificationsDropdownProps> = ({ isOpen }) => {
  const user = useAuth()

  const [state, update] = useGeneralNotifications()

  return (
    <NotificationsPopUp
      onBottomReached={() => update(state.notifications?.length || 0, 20)}
      bottomStopCondition={() => state.final || state.pending}
      dependencies={[user.token]}
      isOpen={isOpen}
      reset={() => update(state.notifications?.length || 0, 10)}
    >
      {
        state.notifications?.map(el => <NotificationItem notification={el} key={el.id} />)
      }
      {
        state.pending && <Loader />
      }
    </NotificationsPopUp>
  )
}

const NotificationsPopUp = styled(PopUp)`
  height: calc(100vh - 100% - 1);
  max-height: calc(100vh - 100%);

  ${up('tablet')} {
    max-height: 70vh;
  }
`

export default NotificationsDropdown